var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "burger-footer right-side" }, [
    _c("nav", [
      _c(
        "ul",
        { staticClass: "footer-menu" },
        [
          _vm._l(_vm.secondaryMenu, function (item) {
            return _c(
              "li",
              {
                key: item.ID,
                class: [
                  "menu-item",
                  "menu-item-type-custom",
                  "menu-item-object-custom",
                  "menu-item-" + item.ID,
                ],
              },
              [
                item.trigger_lead_popup
                  ? _c(
                      "button",
                      {
                        staticClass: "a",
                        class: item.is_current ? "current" : "",
                        on: { click: _vm.$root.toggle_popup },
                      },
                      [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(item.title) },
                        }),
                      ]
                    )
                  : _c("a", { attrs: { href: item.url } }, [
                      _c("span", {
                        domProps: { innerHTML: _vm._s(item.title) },
                      }),
                    ]),
              ]
            )
          }),
          _vm._v(" "),
          _c("li", [
            _c(
              "button",
              {
                staticClass: "current-lang",
                class: _vm.activePage === "lang" ? "hide" : "",
                on: {
                  click: function ($event) {
                    return _vm.$emit("toggleLang")
                  },
                },
              },
              [
                _c("span", { staticClass: "lang-switcher-flag-wrapper" }, [
                  _c("img", {
                    attrs: {
                      src:
                        "https://flagcdn.com/h40/" +
                        _vm.currentLang.flag_code +
                        ".png",
                      srcset:
                        "https://flagcdn.com/h80/" +
                        _vm.currentLang.flag_code +
                        ".png 2x,https://flagcdn.com/h120/" +
                        _vm.currentLang.flag_code +
                        ".png 3x",
                      height: "20",
                      alt: "" + _vm.currentLang.name + " flag",
                    },
                  }),
                ]),
                _vm._v(
                  "\n          " + _vm._s(_vm.currentLang.slug) + "\n          "
                ),
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "9",
                      height: "9",
                      viewBox: "0 0 9 9",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M4.49983 8.87514C3.8442 8.87514 3.22733 8.61951 2.76358 8.15577L0.310452 5.73389C0.0648268 5.49139 0.0623269 5.09576 0.304827 4.85014C0.546702 4.60389 0.942952 4.60264 1.18858 4.84451L3.6442 7.26951C4.10483 7.73014 4.89608 7.72764 5.35108 7.27201L7.81045 4.84451C8.05545 4.60201 8.44983 4.60389 8.6942 4.85014C8.9367 5.09576 8.9342 5.49139 8.68795 5.73389L6.2317 8.15889C5.7717 8.62014 5.15483 8.87514 4.4992 8.87514H4.49983ZM4.94108 5.54576L8.69045 1.81826C8.93545 1.57514 8.9367 1.17951 8.69295 0.934514C8.4492 0.688889 8.0542 0.687639 7.8092 0.932014L4.50045 4.22139L1.19045 0.932014C0.946077 0.688889 0.550452 0.690764 0.306077 0.934514C0.0629519 1.17951 0.064202 1.57514 0.308577 1.81889L4.0592 5.54639C4.18108 5.66764 4.34045 5.72826 4.49983 5.72826C4.6592 5.72826 4.81858 5.66764 4.94045 5.54639L4.94108 5.54576Z",
                        fill: "#CA1744",
                      },
                    }),
                  ]
                ),
              ]
            ),
          ]),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _vm.socialMedia
      ? _c(
          "ul",
          { staticClass: "social-media mt-5" },
          _vm._l(_vm.socialMedia, function (item, index) {
            return _c(
              "li",
              { key: "mega-" + item.link, attrs: { "data-index": index } },
              [
                _c("a", {
                  staticClass: "social-media-icon",
                  class: item.icon,
                  attrs: { href: item.link, target: "_blank" },
                }),
              ]
            )
          }),
          0
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }